// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CityRouteImport } from './routes/$city'
import { Route as AlgemeneVoorwaardenRouteImport } from './routes/algemene-voorwaarden'
import { Route as BewaardRouteImport } from './routes/bewaard'
import { Route as KaartRouteImport } from './routes/kaart'
import { Route as LocatiesRouteImport } from './routes/locaties'
import { Route as OverRouteImport } from './routes/over'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as ZoekenRouteImport } from './routes/zoeken'
import { Route as CityIndexRouteImport } from './routes/$city/index'
import { Route as CityDistrictRouteImport } from './routes/$city/$district'
import { Route as CityDistrictIndexRouteImport } from './routes/$city/$district/index'
import { Route as CityDistrictPlaceRouteImport } from './routes/$city/$district/$place'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CityRoute = CityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => rootRouteImport
          })
const AlgemeneVoorwaardenRoute = AlgemeneVoorwaardenRouteImport.update({
            id: '/algemene-voorwaarden',path: '/algemene-voorwaarden',getParentRoute: () => rootRouteImport
          })
const BewaardRoute = BewaardRouteImport.update({
            id: '/bewaard',path: '/bewaard',getParentRoute: () => rootRouteImport
          })
const KaartRoute = KaartRouteImport.update({
            id: '/kaart',path: '/kaart',getParentRoute: () => rootRouteImport
          })
const LocatiesRoute = LocatiesRouteImport.update({
            id: '/locaties',path: '/locaties',getParentRoute: () => rootRouteImport
          })
const OverRoute = OverRouteImport.update({
            id: '/over',path: '/over',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const ZoekenRoute = ZoekenRouteImport.update({
            id: '/zoeken',path: '/zoeken',getParentRoute: () => rootRouteImport
          })
const CityIndexRoute = CityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CityRoute
          })
const CityDistrictRoute = CityDistrictRouteImport.update({
            id: '/$district',path: '/$district',getParentRoute: () => CityRoute
          })
const CityDistrictIndexRoute = CityDistrictIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CityDistrictRoute
          })
const CityDistrictPlaceRoute = CityDistrictPlaceRouteImport.update({
            id: '/$place',path: '/$place',getParentRoute: () => CityDistrictRoute
          })





const CityDistrictRouteChildren = {
  CityDistrictPlaceRoute: CityDistrictPlaceRoute,CityDistrictIndexRoute: CityDistrictIndexRoute
}

const CityDistrictRouteWithChildren = CityDistrictRoute._addFileChildren(CityDistrictRouteChildren)



const CityRouteChildren = {
  CityDistrictRoute: CityDistrictRouteWithChildren,CityIndexRoute: CityIndexRoute
}

const CityRouteWithChildren = CityRoute._addFileChildren(CityRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CityRoute: CityRouteWithChildren,AlgemeneVoorwaardenRoute: AlgemeneVoorwaardenRoute,BewaardRoute: BewaardRoute,KaartRoute: KaartRoute,LocatiesRoute: LocatiesRoute,OverRoute: OverRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,ZoekenRoute: ZoekenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)